import { useNavigate } from "react-router-dom";
import { Session } from "@supabase/supabase-js";
import { Logo } from "./navigation/Logo";
import { NavLinks } from "./navigation/NavLinks";
import { MobileNav } from "./navigation/MobileNav";

interface NavigationProps {
  session: Session | null;
}

export const Navigation = ({ session }: NavigationProps) => {
  const navigate = useNavigate();

  const handleAuthClick = () => {
    if (session) {
      navigate("/dashboard");
    } else {
      navigate("/auth");
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-skuhub-navy/95 backdrop-blur-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Logo />

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <NavLinks session={session} handleAuthClick={handleAuthClick} />
          </div>

          {/* Mobile Navigation */}
          <div className="md:hidden">
            <MobileNav session={session} handleAuthClick={handleAuthClick} />
          </div>
        </div>
      </div>
    </nav>
  );
};